<template>
  <div>
  <!-- Questa vista serve solo come base per visualizzare il buono toduba   -->
  <ToDuBaBuoni/>
  <!-- Avvia la pagina come toduba -->
  </div>
</template>

<script>

import ToDuBaBuoni from '@/components/toduba/ToDuBaBuoni'

export default {
  name: 'ToDuBa',
  data () {
    return {}
  },
  components: {
    ToDuBaBuoni
  }
}
</script>

<style scoped></style>